import { callApiWithAuthorization } from "../../API/CallApi";

export async function getNode(id, label) {
	const url = "/api/v0/nodes/" + id;
	const query = label ? "?label=" + label : "";
	const resp = await callApiWithAuthorization(url + query);
	const data = await resp.json();
	return data;
}

export async function getAll(fromId, rel, label) {
	const resp = await callApiWithAuthorization("/api/v0/nodes/" + fromId + "/" + rel + "/" + label);
	const data = resp.json();
	return data;
}

export async function createNode(label, properties) {
	const resp = await callApiWithAuthorization("/api/v0/nodes", {
		method: 'POST',
		headers: {
			"Content-Type": 'application/json'
		},
		body: JSON.stringify({
			label: label,
			properties: properties
		})
	})
	const data = resp.json();
	return data;
}


export async function updateNode(label, id, properties) {
	const resp = await callApiWithAuthorization("/api/v0/nodes", {
		method: 'Put',
		headers: {
			"Content-Type": 'application/json'
		},
		body: JSON.stringify({
			id: id,
			label: label,
			properties: properties
		})
	})
	const data = resp.json();
	return data;
}

export async function deleteNode(id, label) {
	const url = "/api/v0/nodes/" + id;
	const query = label ? "?label=" + label : "";
	await callApiWithAuthorization(url + query,{
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json',
		}
	});
}

export function call(url, method) {
	async function withParams(params) {
		const resp = await callApiWithAuthorization('/api/v0/' + url, {
			method: method,
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(params)
		})

		const data = resp.json();
		return data;
	}

	return {
		with: withParams
	}
}

export async function getNodesByLabel(label) {
	const request = await callApiWithAuthorization("/api/v0/nodes?label="+label);
	const response = await request.json();
	return response;
}